import { ICart } from "./cart.model";
import { IContribute } from "./contribute.model";

export interface IPaymentConfig {
  currency?: string;
  enable_sip_switch?: boolean;
  is_sip?: boolean;
  mini_story?: boolean;
  origin?: string;
  sip_contribute_details?: IContribute;
  bypass_for_min_cart_only?: boolean;
  cart_response?: ICart;
  enable_min_cart_lead?: boolean;
}

export const PAYMENT_DEFAULT_CONFIG: IPaymentConfig = {
  enable_sip_switch: false,
  is_sip: false
}